import { useEffect } from 'react'
import { useSimStore } from '../store/simStore'

export function useKeyboard(onCameraReset?: () => void) {
  const { appState, setAppState, runId, rtFactor, setRtFactor } = useSimStore()

  useEffect(() => {
    const handler = async (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLSelectElement) return

      switch (e.key) {
        case ' ':
          e.preventDefault()
          if (appState === 'RUNNING' && runId) {
            setAppState('PAUSED')
            try {
              const res = await fetch(`/api/sim/${runId}/pause`, { method: 'PATCH' })
              if (!res.ok) setAppState('RUNNING')  // revert on failure
            } catch { setAppState('RUNNING') }
          } else if (appState === 'PAUSED' && runId) {
            setAppState('RUNNING')
            try {
              const res = await fetch(`/api/sim/${runId}/resume`, { method: 'PATCH' })
              if (!res.ok) setAppState('PAUSED')
            } catch { setAppState('PAUSED') }
          }
          break
        case '+':
        case '=':
          if (runId && rtFactor > 0) {
            const next = Math.min(2.0, parseFloat((rtFactor * 1.5).toFixed(4)))
            setRtFactor(next)
            try {
              const res = await fetch(`/api/sim/${runId}/rt-factor?rt_factor=${next}`, { method: 'PATCH' })
              if (!res.ok) setRtFactor(rtFactor)  // revert
            } catch { setRtFactor(rtFactor) }
          }
          break
        case '-':
          if (runId && rtFactor > 0) {
            const next = Math.max(0.005, parseFloat((rtFactor / 1.5).toFixed(4)))
            setRtFactor(next)
            try {
              const res = await fetch(`/api/sim/${runId}/rt-factor?rt_factor=${next}`, { method: 'PATCH' })
              if (!res.ok) setRtFactor(rtFactor)
            } catch { setRtFactor(rtFactor) }
          }
          break
        case 'f':
        case 'F':
          if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(() => {})
          } else {
            document.exitFullscreen().catch(() => {})
          }
          break
        case 'r':
        case 'R':
          onCameraReset?.()
          break
        case 'Escape':
          if (document.fullscreenElement) {
            document.exitFullscreen().catch(() => {})
          }
          break
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [appState, runId, rtFactor, setAppState, setRtFactor, onCameraReset])
}
